import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { wapiInvoicesRepositoryBuilder } from './WapiInvoicesRepository'

export const wapiInvoicesRepository = () => {
  return wapiInvoicesRepositoryBuilder({
    httpService: new AxiosHttpServiceBuilder()
  })
}
